module.exports = __webpack_public_path__ + "fonts/montserrat-extrabold-webfont.b940eba.woff";